import { Divider, Form, Grid, Input, Text } from '@wework/dieter-ui'
import React from 'react'
import IMTheme from '../../style/IMTheme'

export default function EditPermissions() {
  return (
    <div>
      <Grid style={{ marginTop: IMTheme.spacing[5] }}>
        <Grid.Row stretched>
          <Grid.Column>
            <div>
              <Text style={{ fontWeight: 'bold', fontSize: 16 }}>
                Permissions
              </Text>
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row stretched>
          <Grid.Column>
            <div>
              <Text size="small" style={{ color: '#777' }}>
                To view or make any changes to permissions, please go to{' '}
                <a href="https://rooms.wework.com/">Rooms Admin</a>.
              </Text>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  )
}
